module.exports = __webpack_public_path__ + "img/logo-fifalotto-white4-tgone_.a7412a3f.png";